import { Factory } from '../../services/Factory';

namespace app.directives.reporting.tracking {

  export interface IAnchorTrackerScope extends angular.IScope {
  }

  export interface IAnchorTrackerAttributes extends angular.IAttributes {
  }

  export class AnchorTracker implements angular.IDirective {
    public restrict = 'E';
    public scope = false;
    public replace = false;
    public priority = 100;
    public link: (scope: IAnchorTrackerScope, element: angular.IAugmentedJQuery, attrs: IAnchorTrackerAttributes) => void;

    constructor(trackService: app.services.auditing.TrackService) {
      this.link = (scope: IAnchorTrackerScope, element: angular.IAugmentedJQuery, attrs: IAnchorTrackerAttributes) => {
        let trackString = "";

        attrs.$observe('track', (value: string) => value && (trackString = value));

        element.bind('click', () => trackService.ClickHandler(trackString, element));
      }
    };
  }

  frontendApp.directive("a", ["TrackService", Factory.Create(AnchorTracker)]);
}
